<script setup lang="ts" generic="T extends any">
    import { Swiper, SwiperSlide } from 'swiper/vue';

    type SlideWithAb = {
        ab_test?: {
            ab_test?: string;
        };
    };

    type ContentSliderProps = {
        slideData: T[];
        ariaLabelNext?: string;
        ariaLabelPrevious?: string;
        gap?: number;
    };

    const props = defineProps<ContentSliderProps>();

    const { setMainSwiper, onSlideFocus, componentProps, sliderProps } = useSliderPeak(1.2, 2.2, 4, props.gap || 16);

    const getAbTargetClass = (slide: T) => (slide as SlideWithAb)?.ab_test?.ab_test;
</script>
<template>
    <atm-container
        class="mol-content-slider py-8 md:py-10"
        v-bind="componentProps">
        <nuxt-error-boundary @error="() => {}">
            <swiper
                v-bind="sliderProps"
                @swiper="setMainSwiper"
                auto-height>
                <swiper-slide
                    v-for="(data, index) in slideData"
                    :class="getAbTargetClass(data)"
                    :key="index"
                    :index="index"
                    class="flex! h-full! flex-col"
                    @focusin="() => onSlideFocus(index)">
                    <atm-slide-index-provider :index="index">
                        <slot
                            :data="data"
                            :index="index"></slot>
                    </atm-slide-index-provider>
                </swiper-slide>
                <mol-slider-navigation />
            </swiper>
        </nuxt-error-boundary>
    </atm-container>
</template>
